import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import ForgetPassword from './components/ForgetPassword';
import Dashboard from './components/Dashboard';
import PatientHistory from './components/PatientHistory';
import PatientDetails from './components/PatientDetails';
import AppoinmentHistory from './components/AppoinmentHistory';
import CreateAppoinment from './components/CreateAppoinment';
import CreatePrescription from './components/CreatePrescription';
import CreateDoctor from './components/CreateDoctor';
import DoctorHistory from './components/DoctorHistory';
import CreatePatient from './components/CreatePatient';
import { isAuthenticated } from './components/helper/auth'; // Import the auth check
import PrescriptionPreview from './prescriptionPreview/prescriptionPreview';
import UpdatePatient from './components/UpdatePatient';
import UpdateDoctor from './components/UpdateDoctor';
import UpdateAppoinment from './components/UpdateAppoinment';
import ChangePassword from './components/ChangePassword';
import UpdateProfile from './components/UpdateProfile';
import Report from './components/Report';


// Protected Route component
const ProtectedRoute = ({ element: Element }) => {
  return isAuthenticated() ? <Element /> : <Navigate to="/" />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="/" element={<Login />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/prescription-preview/:prescription_id"  element={<PrescriptionPreview/>} />
        {/* Protected routes */}
        <Route path="/dashboard" element={<ProtectedRoute element={Dashboard} />} />
        <Route path="/patient-history" element={<ProtectedRoute element={PatientHistory} />} />
        <Route path="/create-patient" element={<ProtectedRoute element={CreatePatient} />} />
        <Route path="/update-patient/:id" element={<ProtectedRoute element={UpdatePatient} />} /> {/* UpdatePatient Route */}
        <Route path="/patient-details/:id" element={<ProtectedRoute element={PatientDetails} />} />
        <Route path="/appoinment-history" element={<ProtectedRoute element={AppoinmentHistory} />} />
        <Route path="/create-appoinment" element={<ProtectedRoute element={CreateAppoinment} />} />
        <Route path="/update-appoinment/:id" element={<ProtectedRoute element={UpdateAppoinment} />} />
        <Route path="/create-prescription" element={<ProtectedRoute element={CreatePrescription} />} />
        <Route path="/doctor-history" element={<ProtectedRoute element={DoctorHistory} />} />
        <Route path="/create-doctor" element={<ProtectedRoute element={CreateDoctor} />} />
        <Route path="/update-doctor/:id" element={<ProtectedRoute element={UpdateDoctor} />} /> {/* UpdatePatient Route */}
        <Route path="/change-password" element={<ProtectedRoute element={ChangePassword} />} />
        <Route path="/profile" element={<ProtectedRoute element={UpdateProfile} />} />
        <Route path="/report" element={<ProtectedRoute element={Report} />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;
